import Link from "next/link";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { device } from "../theme/Breakpoints";
import { Color } from "../theme/Color";
import { FontSizes } from "../theme/FontSize";

interface Props {
  action: string;
  hint?: string;
  link: string;
  actionColor?: Color;
}

const StyledActionWithHint = styled(Row)``;

export const ActionTitle = styled(Row)<{
  color: Color;
}>`
  font-size: ${FontSizes[3]};
  text-decoration: underline;
  line-height: 160%;
  color: ${({ color }) => (color ? color : "")};

  display: block;
  width: 100%;
  text-align: center;

  & a {
    color: ${({ color }) => (color ? color : Color.Black)};
  }

  &:hover {
    cursor: hand;
  }

  @media ${device.mdAndWider} {
    font-size: ${FontSizes[5]};
  }
`;

const ActionSubtitle = styled.h2`
  font-size: ${FontSizes[0]};

  & a,
  & a:visited {
    color: ${Color.Orange5};
    text-decoration: none;
  }

  &:hover {
    cursor: pointer;
  }
`;

const ActionWithHint = ({
  action,
  hint,
  link,
  actionColor = Color.Black,
}: Props) => {
  return (
    <StyledActionWithHint>
      <Col xs={12}>
        <Row center="xs">
          <ActionTitle color={actionColor}>
            <Link href={link}>
              <a>{action}</a>
            </Link>
          </ActionTitle>
        </Row>
        <Row center="xs">
          <ActionSubtitle>
            <Link href={link}>
              <a>{hint}</a>
            </Link>
          </ActionSubtitle>
        </Row>
      </Col>
    </StyledActionWithHint>
  );
};

export default ActionWithHint;
